module.exports = "body {\n    background-color: #f6f6f6\n}"